document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('[data-bbba-hero]').forEach(function (hero) {
    var slides = Array.prototype.slice.call(hero.querySelectorAll('.bbba-hero__slide'));
    var dots = Array.prototype.slice.call(hero.querySelectorAll('.bbba-hero__dot'));
    var prevBtn = hero.querySelector('.bbba-hero__arrow--prev');
    var nextBtn = hero.querySelector('.bbba-hero__arrow--next');
    var current = 0;
    var timer = null;
    var autoplay = hero.getAttribute('data-autoplay') === 'true';
    var interval = parseInt(hero.getAttribute('data-interval'), 10) || 5000;

    if (slides.length <= 1) return;

    function goTo(index) {
      slides[current].classList.remove('is-active');
      if (dots[current]) dots[current].classList.remove('is-active');
      current = (index + slides.length) % slides.length;
      slides[current].classList.add('is-active');
      if (dots[current]) dots[current].classList.add('is-active');
    }

    function next() { goTo(current + 1); }
    function prev() { goTo(current - 1); }

    function startAutoplay() {
      if (!autoplay) return;
      stopAutoplay();
      timer = setInterval(next, interval);
    }

    function stopAutoplay() {
      if (timer) clearInterval(timer);
    }

    if (nextBtn) nextBtn.addEventListener('click', function () { next(); startAutoplay(); });
    if (prevBtn) prevBtn.addEventListener('click', function () { prev(); startAutoplay(); });

    dots.forEach(function (dot, i) {
      dot.addEventListener('click', function () {
        goTo(i);
        startAutoplay();
      });
    });

    hero.addEventListener('mouseenter', stopAutoplay);
    hero.addEventListener('mouseleave', startAutoplay);

    startAutoplay();
  });
});